import { gql } from '@apollo/client'

export const GET_CATEGORY_DOCUMENT = gql`
    query GetCategory($url_path: String!) {
        categories(filters: {url_path: {eq: $url_path}},pageSize: 50) {
            items {
                name
                id
                uid
                url_key
                url_path
                level
                meta_title
                meta_keywords
                meta_description
                image
                header_name
                description
                default_sort_by
                children_count
                category_seo_name
                catalog_top_description
                catalog_bottom_description
                breadcrumbs {
                    category_name
                    category_uid
                    category_url_key
                    category_level
                }
                children {
                    uid
                    name
                    url_key
                    url_path
                    include_in_menu
                }
                __typename
            }
            __typename
        }
    }
`